import { Filter } from "../types/PageFilterTypes";

export const getFilters = (
  values: Filter[]
): { text: string; value: string }[] => {
  return values
    .map(({ key, displayValue }) => ({
      text: displayValue,
      value: key as string,
    }))
    .sort((a, b) => a.text.localeCompare(b.text));
};
export const applyFilter = (
  key?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): ((value: string, record: any) => boolean) => {
  return (value, record) => {
    const target = key ? record[key] : record;

    if (typeof target === "string") {
      return target.includes(value);
    }

    if (typeof target === "number" || typeof target === "boolean") {
      return String(target) === value;
    }

    return false;
  };
};

export const generateFilters = (
  values: string[]
): { value: string; text: string }[] => {
  return values.map((value) => ({
    text: value,
    value,
  }));
};
